import React from 'react'

function BalanceDisplay({ balance, loading, couple, currentUserId }) {
  if (loading) {
    return (
      <div className="balance-display loading">
        <div className="balance-label">Calculating...</div>
        <div className="balance-amount">---</div>
      </div>
    )
  }

  // Get partner name
  const partnerName = couple?.members?.find(m => m.user_id !== currentUserId)?.display_name || 'Partner'

  // Positive balance = partner owes me
  // Negative balance = I owe partner
  const absBalance = Math.abs(balance).toFixed(2)

  let statusText, statusClass

  if (balance === 0) {
    statusText = "All settled up!"
    statusClass = "settled"
  } else if (balance > 0) {
    statusText = `${partnerName} owes you`
    statusClass = "she-owes"
  } else {
    statusText = `You owe ${partnerName}`
    statusClass = "i-owe"
  }

  return (
    <div className={`balance-display ${statusClass}`}>
      <div className="balance-label">{statusText}</div>
      {balance !== 0 && (
        <div className="balance-amount">${absBalance}</div>
      )}
    </div>
  )
}

export default BalanceDisplay
